import React from 'react';
import { observer } from 'mobx-react-lite';
import armbeygja from '../images/armbeygja_small.png';
import armretta from '../images/armretta_small.png';
import framanverdlaeri from '../images/framanverdlaeri_small.png';
import aftanverdlaeri from '../images/aftanverdlaeri_small.png';
import axlir from '../images/axlir_small.png';
import bakvodvar_nidurtog from '../images/bakvodvar_nidurtog_small.png';
import bakvodvar_rodur from '../images/bakvodvar_rodur_small.png';
import brjostvodvar from '../images/brjostvodvar_small.png';
import fotapressa from '../images/fotapressa_small.png';
import innanverdlaeri from '../images/innanverdlaeri_small.png';
import utanverdlaeri from '../images/utanverdlaeri_small.png';
import kvidaefing from '../images/abs_small.png';
import bakaefing from '../images/bakaefing_small.png';

export const EquipmentImageSmall = observer(({ number }) => {
  const image = numberMap[number];
  if (!image) return null;
  return (
    <div
      style={{
        position: 'absolute',
        bottom: 0,
        left: 10,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        top: 0,
      }}
    >
      <img src={image} width="80" style={{ maxHeight: 80 }} alt="mynd æfingar" />
    </div>
  );
});

const numberMap = {
  1: armbeygja,
  2: armretta,
  3: framanverdlaeri,
  4: aftanverdlaeri,
  5: brjostvodvar,
  6: bakvodvar_rodur,
  7: innanverdlaeri,
  8: utanverdlaeri,
  9: bakvodvar_nidurtog,
  10: axlir,
  11: fotapressa,
  12: fotapressa,

  13: kvidaefing,
  14: bakaefing,
};
